import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Drag.svg'

export const IconDrag = IconSVG as IconComponent
